<template>
  <div id="personInfo">
    <Nav v-if="PsjID" />
    <div class="step-box step-box2" style="display:none">
      <!-- 没有配置步骤图 -->
      <el-steps :active="stepNum" v-if="stepImg.length<=0" align-center>
        <div style="width:100%;">
          <el-step title="个人信息"></el-step>
          <!-- 是否有问卷 -->
          <el-step v-if="!IfSubmit" title="填写问卷"></el-step>
          <el-step title="报名成功"></el-step>
        </div>
      </el-steps>
      <img v-else :src="stepImg[0]" alt="">
    </div>
    <div class="personInfobox" :style="syStyle">
      <h3 class="title">填写个人信息</h3>
      <el-form :model="ruleForm2" ref="ruleForm" label-width="100px" class="demo-ruleForm from-wrap">
        <div @click="showEmailTip=false">
          <div>
            <!-- 头像 -->
            <div
              style='text-align:left;'
              class="form-item"
              label="头像"
              prop=""
              v-if="PhotoModel"
            >
              <div>头像<b v-if="IsRequiredPhoto" style="color: red">*</b></div>
              <div style="width:100%; text-align:center;">
                <img :src="pmp" style="width:150px;" v-if="!photoImg" alt="" @click="uploadPicture('flagImg')">
                <span class="photoImg" v-else>
                  <img :src="photoImg" style="width:120px;" alt="" @click="uploadPicture('flagImg')">
                  <div class="photoBtns">
                    <el-button size="small" @click="deletePhoto">删除</el-button>
                    <el-button size="small" @click="uploadPicture('flagImg')">重新上传</el-button>
                  </div>
                </span>
              </div>
            </div>
          </div>
          <div v-for="(item,index) in inputCofigData" :key="index">
            <!-- 姓名 -->
            <div
              class="form-item"
              :label="item.title"
              prop="rgname"
              v-if="item.name==='PsnName'&&item.optional"
            >
              <div>
                {{item.title}}
                <b v-if="item.required" style="color: red">*</b>
              </div>
              <el-input
                @blur="clearSpace('userName')"
                v-model="ruleForm2.userName"
                :name="item.name"
                :placeholder="item.placeholder"
                maxlength="50"
              ></el-input>
            </div>
            <!-- 公司 -->
            <div
              class="form-item"
              :label="item.title"
              v-if="item.name==='PsnComName'&&item.optional"
              prop="rgComName"
            >
              <div>
                {{item.title}}
                <b v-if="item.required" style="color: red">*</b>
              </div>
              <el-input
                @blur="clearSpace('comName')"
                v-model="ruleForm2.comName"
                :name="item.name"
                :placeholder="item.placeholder"
                maxlength="50"
              ></el-input>
            </div>
            <!-- 性别 -->
            <div
              class="form-item sex"
              :label="item.title"
              prop="rgSex"
              v-if="item.name==='PsnGender'&&item.optional"
            >
              <div>
                {{item.title}}
                <b v-if="item.required" style="color: red">*</b>
              </div>
              <el-radio v-model="ruleForm2.sex" checked label="先生" @change="cacheInput">先生</el-radio>
              <el-radio v-model="ruleForm2.sex" label="女士" @change="cacheInput">女士</el-radio>
            </div>
            <!-- 职务 -->
            <div
              class="form-item"
              :label="item.title"
              v-if="item.name==='PsnRank'&&item.optional"
              prop="rgRank"
            >
              <div>
                {{item.title}}
                <b v-if="item.required" style="color: red">*</b>
              </div>
              <el-input
                @blur="clearSpace('rank')"
                v-model="ruleForm2.rank"
                :name="item.name"
                :placeholder="item.placeholder"
                maxlength="50"
              ></el-input>
            </div>
            <!-- 部门 -->
            <div
              class="form-item"
              :label="item.title"
              v-if="item.name==='PsnDept'&&item.optional"
              prop="rgDepar"
            >
              <div>
                {{item.title}}
                <b v-if="item.required" style="color: red">*</b>
              </div>
              <el-input
                @blur="clearSpace('depar')"
                v-model="ruleForm2.depar"
                :name="item.name"
                :placeholder="item.placeholder"
                maxlength="50"
              ></el-input>
            </div>
            <!-- 手机 -->
            <div
              class="form-item"
              :label="item.title"
              v-if="item.name==='PsnMobile'&&item.optional"
              prop="rgIphone"
            >
              <div>
                {{item.title}}
                <b v-if="item.required" style="color: red">*</b>
              </div>
              <el-input
                type="number"
                :disabled="true"
                v-model="ruleForm2.iphone"
                @keyup.native="clearSpace('iphone')"
                :placeholder="item.placeholder"
                maxlength="11"
                :name="item.name"
              ></el-input>
            </div>
            <!-- 国家 -->
            <div
              class="form-item"
              :label="item.title"
              prop="rgEmptyCountry"
              v-if="showCountry&&item.name==='PsnCountry'&&item.optional"
            >
              <div>
                {{item.title}}
                <b v-if="item.required" style="color: red">*</b>
              </div>
              <el-select
                v-model="ruleForm2.country"
                :loading="isLoading"
                @visible-change="loadCountry"
                @change="changeCountry"
                :placeholder="item.placeholder"
                :name="item.name"
              >
                <el-option label="中国大陆" value="086"></el-option>
                <el-option
                  v-for="(item,index) in countryArr"
                  :label="item.zptCity"
                  :value="item.zptCityCode"
                  :key="index"
                ></el-option>
              </el-select>
            </div>
            <!-- 省份 -->
            <div
              class="form-item"
              label="省份"
              prop="rgEmptyProvince"
              v-if="(ruleForm2.telGnum=='086'||ruleForm2.telGnum=='86')&&item.name=='PsnProvince'&&item.optional"
            >
              <div>
                {{item.title}}
                <b v-if="item.required" style="color: red">*</b>
              </div>
              <el-select
                @change="cacheInput('province')"
                v-model="ruleForm2.province"
                @visible-change="loadProvince"
                placeholder="请选择省份"
                :name="item.name"
              >
                <el-option
                  v-for="(item,index) in provinceArr"
                  :label="item.zptCity"
                  :value="item.zptCity"
                  :key="index"
                ></el-option>
              </el-select>
            </div>
            <!-- 城市 -->
            <div
              class="form-item"
              label="城市"
              prop="rgEmptyCity"
              v-if="(ruleForm2.telGnum=='086'||ruleForm2.telGnum=='86')&&item.name=='PsnCity'&&item.optional&&ruleForm2.province"
            >
              <div>
                {{item.title}}
                <b v-if="item.required" style="color: red">*</b>
              </div>
              <el-select
                @visible-change="loadCity"
                v-model="ruleForm2.city"
                @change="changeCity"
                placeholder="请选择城市"
                :name="item.name"
              >
                <el-option
                  v-for="(item,index) in cityArr"
                  :label="item.zptCity"
                  :value="item.zptCityCode"
                  :key="index"
                ></el-option>
              </el-select>
            </div>
            <!-- 地址 -->
            <div
              class="form-item"
              :label="item.title"
              v-if="item.name=='PsnAddress'&&item.optional"
              prop="rgAddr"
            >
              <div>
                {{item.title}}
                <b v-if="item.required" style="color: red">*</b>
              </div>
              <el-input
                @blur="clearSpace('addr')"
                v-model="ruleForm2.addr"
                :placeholder="item.placeholder"
                :name="item.name"
                error="dsfs"
                maxlength="50"
              ></el-input>
            </div>
            <!-- 邮箱 -->
            <div
              class="form-item"
              :label="item.title"
              v-if="item.name==='PsnEmail'&&item.optional"
              prop="rgEmeil"
              :hide-required-asterisk="item.required"
            >
              <div>
                {{item.title}}
                <b v-if="item.required" style="color: red">*</b>
              </div>
              <el-input
                maxlength="50"
                :name="item.name"
                @keyup.native.space="clearSpace('email')"
                v-model="ruleForm2.email"
                :placeholder="item.placeholder"
                @input="changeEmail"
                :disabled="!!PsjID"
                error
              ></el-input>
              <div class="email-tip" v-if="item.name==='PsnEmail'&&showEmailTip">
                <div
                  class="email-tip-option"
                  v-for="(item,index) in emailArr"
                  :key="index"
                  @click="chooseEmailSuffix(item)"
                >{{ruleForm2.email.split('@')[0]+item}}</div>
              </div>
            </div>
            <!-- 网址 -->
            <div
              class="form-item"
              :label="item.title"
              v-if="item.name==='PsnWebUrl'&&item.optional"
              prop="rgWebUrl"
            >
              <div>
                {{item.title}}
                <b v-if="item.required" style="color: red">*</b>
              </div>
              <el-input
                maxlength="50"
                :name="item.name"
                @keyup.native.space.passive="clearSpace('webUrl')"
                :placeholder="item.placeholder"
                v-model="ruleForm2.webUrl"
                class="input-with-select"
                @change="cacheInput"
              ></el-input>
            </div>
            <!-- 传真 -->
            <div
              class="form-item tel"
              :label="item.title"
              v-if="item.name==='PsnFax'&&item.optional"
              prop="rgFax"
            >
              <div>
                {{item.title}}
                <b v-if="item.required" style="color: red">*</b>
              </div>
              <div style="width:88%;display: flex;">
                <el-input
                  @keyup.native="clearSpace('gNum')"
                  style="width: 30%;min-width: 66px;"
                  v-model="ruleForm2.gNum"
                  placeholder="国家号"
                  maxlength="4"
                ></el-input>-
                <el-input
                  @keyup.native="clearSpace('cNum')"
                  style="width: 30%;min-width: 66px;"
                  v-model="ruleForm2.cNum"
                  placeholder="区号"
                  maxlength="11"
                  v-if="ruleForm2.gNum=='086'||ruleForm2.gNum=='86'"
                ></el-input>
                <span v-if="ruleForm2.gNum=='086'||ruleForm2.gNum=='86'">-</span>
                <el-input
                  @keyup.native="clearSpace('faxNum')"
                  v-model="ruleForm2.faxNum"
                  placeholder="传真号"
                  :name="item.name"
                  class="tel"
                ></el-input>
              </div>
            </div>
            <!-- 座机 -->
            <div
              class="form-item tel"
              :label="item.title"
              v-if="item.name==='PsnTel'&&item.optional"
              prop="rgTel"
            >
              <div>
                {{item.title}}
                <b v-if="item.required" style="color: red">*</b>
              </div>
              <div style="width:88%;display: flex;">
                <el-input
                  @keyup.native="clearSpace('gNum')"
                  style="width: 30%;min-width: 66px;"
                  v-model="ruleForm2.gNum"
                  placeholder="国家号"
                  maxlength="4"
                ></el-input>-
                <el-input
                  @keyup.native="clearSpace('cNum')"
                  style="width: 30%;min-width: 66px;"
                  v-model="ruleForm2.cNum"
                  placeholder="区号"
                  maxlength="11"
                  v-if="ruleForm2.gNum === '086'||ruleForm2.gNum === '86'"
                ></el-input>
                <span v-if="ruleForm2.gNum === '086'||ruleForm2.gNum === '86'">-</span>
                <el-input
                  @keyup.native="clearSpace('telNum')"
                  v-model="ruleForm2.telNum"
                  placeholder="电话号"
                  :name="item.name"
                  class="tel"
                ></el-input>
              </div>
            </div>
            <!-- 行业 -->
            <div
              class="form-item"
              :label="item.title"
              v-if="item.name==='PsnTrade'&&item.optional"
              prop="rgEmptyIndustry"
              palceholder="请选择行业"
            >
              <div>
                {{item.title}}
                <b v-if="item.required" style="color: red">*</b>
              </div>
              <el-select v-model="ruleForm2.industry" @change="cacheInput" :name="item.name">
                <el-option v-for="(item,index) in item.data" :key="index" :label="item" :value="item"></el-option>
              </el-select>
            </div>
            <!-- 身份证 -->
            <div
              class="form-item"
              :label="item.title"
              v-if="item.name==='PsnIDCard'&&item.optional"
              prop="rgCId"
            >
              <div>
                {{item.title}}
                <b v-if="item.required" style="color: red">*</b>
              </div>
              <el-input
                maxlength="18"
                :name="item.name"
                @keyup.native.space.passive="clearSpace('cId')"
                v-model="ruleForm2.cId"
                :placeholder="item.placeholder"
                @change="cacheInput"
              ></el-input>
            </div>
            <!-- <div v-if="item.name==='PsnIDCard'"><span style="padding-left: 20%;color: red;">根据相关部门规定，需实名认证</span></div> -->
            <!-- pass -->
            <div
              class="form-item"
              :label="item.title"
              v-if="item.name==='PsnLoginPwd'&&item.optional"
              prop="rgPassword"
            >
              <div>
                {{item.title}}
                <b v-if="item.required" style="color: red">*</b>
              </div>
              <el-input
                maxlength="18"
                @keyup.native.space.passive="clearSpace('password')"
                type="password"
                v-model="ruleForm2.password"
                :placeholder="item.placeholder"
                @change="cacheInput"
                :name="item.name"
              ></el-input>
            </div>
            <!-- 确认密码 -->
            <div
              class="form-item"
              label="确认密码"
              v-if="item.name==='PsnLoginPwd'&&item.optional"
              prop="confirmPassword"
            >
              <div>
                确认密码
                <b v-if="item.required" style="color: red">*</b>
              </div>
              <el-input
                maxlength="18"
                @keyup.native.space.passive="clearSpace('confirmPassword')"
                type="password"
                v-model="confirmPassword"
                placeholder="请再次输入密码"
                @change="cacheInput"
                name="confirmPassword"
              ></el-input>
            </div>
            <!-- 邮编 -->
            <div
              class="form-item"
              :label="item.title"
              v-if="item.name=='PsnZipCode'&&item.optional"
              prop="rgPostcode"
            >
              <div>
                {{item.title}}
                <b v-if="item.required" style="color: red">*</b>
              </div>
              <el-input
                @keyup.native.space.passive="clearSpace('postcode')"
                v-model="ruleForm2.postcode"
                :placeholder="item.placeholder"
                @change="cacheInput"
                :name="item.name"
              ></el-input>
            </div>
            <!-- 备注 -->
            <div
              class="form-item"
              :label="item.title"
              v-if="item.name==='PsnRemark'&&item.optional"
              prop="rgRemark"
            >
              <div>
                {{item.title}}
                <b v-if="item.required" style="color: red">*</b>
              </div>
              <el-input
                maxlength="50"
                v-model="ruleForm2.remark"
                :placeholder="item.placeholder"
                @change="cacheInput"
                @keyup.native.space.passive="clearSpace('remark')"
                :name="item.name"
              ></el-input>
            </div>
          </div>
          <div class="privacySwitch" style="font-size:12px;line-height:18px;">商业广告：我们可能会将您的个人信息用于向您推送您感兴趣的商业广告。您可以通过推送中的相关指示退订该商业广告。</div>
          <!-- 授权 -->
          <div class="privacySwitch" v-if="privacySwitch&&privacyInfo">
            <el-checkbox v-model="isChecked"></el-checkbox>
            <div class='privacyTxt' :style="{color:btnAllStyle.background}" @click="yszcVisible = true">我已知晓本服务的功能，已阅读隐私政策的全部内容并同意根据其条款对本人信息的处理，以及使用本人个人信息向我发送商业广告。</div>
            <!-- <div class="privacyTxt" v-html="privacyInfo"></div> -->
          </div>

          <div class="privacySwitch">
            <el-checkbox v-model="isChecked2"></el-checkbox>
            <div class='privacyTxt2' :style="{color:btnAllStyle.background}" >我已知晓主办方可能会在展会现场拍摄图片或视频等，我同意主办方将含有本人形象的照片或视频用于展会宣传之用途。</div>
          </div>


          <el-button
            :style="btnAllStyle"
            type="primary"
            class="Personinfo-submit-btn"
            :loading="showBtnLoading"
            @click="submit('ruleForm')"
          >{{PsjID? '保存': '下一步'}}</el-button>
        </div>
      </el-form>
    </div>
    <!-- 剪裁组件弹窗 -->
    <el-dialog
      title="上传头像"
      :visible.sync="cropperModel"
      width="800px"
      center
      >
     <cropper-image
      :Name="cropperName"
      @uploadImgSuccess = "handleUploadSuccess"
      ref="child">
     </cropper-image>
    </el-dialog>
    <!--查看头像-->
    <el-dialog
        title="头像"
        :visible.sync="imgVisible"
        center>
      <img :src="imgName" v-if="imgVisible" style="width: 100%" alt="查看">
    </el-dialog>

    <el-dialog
        title="隐私政策相关条款"
        :visible.sync="yszcVisible"
        top='10px'
        center>
        <div class="ystkBox">
          <div class="pdText">
            <div class="smallTip">原则</div>
            <div class="pdContent">慕尼黑展览（上海）有限公司感谢您访问我们的网站，也感谢您对本公司和我们的产品感兴趣。我们非常重视保护您的个人隐私数据，希望您在访问我们的网页时感到放心。保护您的隐私对我们而言至关重要，因此，我们一定会遵守数据保护方面的强制性法规。我们的员工也有义务确保所有信息保密，公司会为他们提供数据保护和安全方面的常规培训。下面向您简单介绍我们如何保护您的隐私数据，以及当您使用我们的在线服务时，您的数据会如何被使用。</div>
          </div>
       
          <div  class="pdText">
            <div class="smallTip">数据访问</div>
            <div class="pdContent">当有人访问我们的网页时，慕尼黑展览（上海）有限公司会收到访问数据，并将以保护目的将其保存下来，以便我们识别您。此类数据包括</div>
            <div class="pdContent">• 网络服务提供商的名称</div>
            <div class="pdContent">• 所在国家</div>
            <div class="pdContent">• 从哪个网站访问我们</div>
            <div class="pdContent">• 如果您是从搜索引擎访问，所使用的搜索关键词是什么</div>
            <div class="pdContent">• 您访问了我们哪个网站</div>
            <div class="pdContent">• 用户访问所使用的工具（浏览器、操作系统）</div>
            <div class="pdContent">• 从我们的网站下载的文件（如PDF或word文档）</div>
            <div class="pdContent">• 访问持续时间</div>
            <div class="pdContent">• 访问日期和时间</div>
          </div>

          <div  class="pdText">
            <div class="pdContent">这些信息能够帮助我们优化服务，并能在一些条件下，例如您再次访问时，为您量身定制内容。如果您已经有数据存储在我们这里，多数情况下，新数据会被更新到已有数据中。</div>
          </div>

          <div  class="pdText">
            <div class="smallTip">个人数据</div>
            <div class="pdContent">个人数据是指能够单独或者与其他信息结合明确确定您的身份的信息。我们向您收集的个人数据包括但不限于您的用户名、姓名、称谓、公司名称、所在部门、职位、省份、通讯地址、邮编、座机号、手机号、通讯语言和电子邮件地址等。我们只在您自愿提供时才保留此类个人数据，如作为注册的一部分、调查、参加抽奖、联系人调查、新闻稿发送或在线订单处理等。此外，个人数据仅在必要时使用，且只在您许可的情况下用于合法用途。为确保您的数据传输安全，慕尼黑展览（上海）有限公司会在一些安全区域采用加密手段。也就是说，原则上第三方无法读取您的浏览器和我们的网站之间的通信。另外，使用我们的网站即意味着您知晓并同意慕尼黑展览（上海）有限公司收集、储存和使用您的个人数据，以及将您的个人数据提供给其境内外的集团公司与合作伙伴储存和使用。</div>
        
          </div>


   
          <div  class="pdText">
            <div class="smallTip">向第三方传递个人数据</div>
            <div class="pdContent">慕尼黑展览（上海）有限公司在一些服务中引入了一些高质量的合作伙伴。这些伙伴均遵守慕尼黑展览（上海）有限公司在数据保护中所遵守的强制性规定。我们仅在如下情况下才向该等第三方传递个人数据</div>
            <div class="pdContent">• 在我们通过本网站向您提供任何服务的过程中确实需要接受来自第三方的服务，而相关服务的提供依赖于您的个人数据；在此情形下我们会向您进行明确说明，您可以予以拒绝我们向相关第三方传递您的个人数据，但您的此项拒绝将导致我们无法向您提供相关服务；</div>
            <div class="pdContent">• 您已经事先给予许可的一些例外情况</div>
          </div>


          <div  class="pdText">
            <div class="pdContent">其他信息 - 如您自愿提供的主要兴趣等 - 不会被传递给第三方。只有在有关法律法规或有权机关要求的范围内，个人数据才会被传递给相应有权机关。</div>
          </div>

          <div  class="pdText">
            <div class="smallTip">发送商业信息</div>
            <div class="pdContent">我们可能使用您的个人信息向您推送商业信息，包括但不限于通过信件、电子邮件、短信/彩信和电话。向我们提供您的个人信息，即表示您同意并知晓我们使用该个人信息向您推送商业信息。您可以通过推送中的相关指示退订该商业信息推送。</div>
            <div class="pdContent"></div>
          </div>


          <div  class="pdText">
            <div class="smallTip">删除个人数据的请求</div>
            <div class="pdContent">您可以通过电子邮件等书面通知的方式向慕尼黑展览（上海）有限公司要求停止使用或删除您的个人数据。</div>
          </div>



          <div  class="pdText">
            <div class="smallTip">Cookies</div>
            <div class="pdContent">Cookies是一些小文本文件，这类文件在中国和全世界均广泛使用。Cookies文件在您访问我们网站时建立，并由我们的服务器存储在您的硬盘上。我们的cookies中不含有任何特定个人的信息。此外，由我们的服务器存储的cookies只能由我们读取，其他外部网站不能读取。多数浏览器默认自动接受cookies，如果您不希望使用cookies，可以在浏览器中关闭该功能。请您事先了解自己浏览器的各种设置。不使用cookies您也可以访问我们的网站，但是可能会限制我们为您提供的服务。</div>
            <div class="pdContent">此外，在本网站运行过程中，为了优化向您提供的服务，除了以上所述Cookies以外，我们还可能引入其他数据处理或收集技术。在我们引入该等技术前，我们将进行通知并相应修改数据保护条款。与Cookies相同，您可以在访问我们的网站的任何时候拒绝适用该等技术。</div>
          </div>



          <div  class="pdText">
            <div class="smallTip">其他活动数据 (如Javascript, ActiveX)</div>
            <div class="pdContent">如果有安全需要，您可以在任何时候在浏览器中关闭Javascript、ActiveX和其他含有可执行元素的网络控件和脚本语言。我们的网页在关闭Javascript后仍可正常浏览。</div>
          </div>

          <div  class="pdText">
            <div class="smallTip">链接</div>
            <div class="pdContent">慕尼黑展览（上海）有限公司的一些网页中含有通往其他网站的链接。我们已经尽到了合理的注意义务检查这些网站。但是，慕尼黑展览（上海）有限公司不对网站中外部链接的任何内容承担责任。慕尼黑展览（上海）有限公司也不对链接到或提及了慕尼黑展览（上海）有限公司的网站中的任何内容负责。</div>
          </div>

          <div  class="pdText">
              <div class="smallTip">修改</div>
              <div class="pdContent">慕尼黑展览（上海）有限公司保留在任何时候，在符合相关法律法规的规定的前提下，修改数据保护条款的权利。</div>
          </div>

          <div  class="pdText">
            <div class="smallTip">提问和建议:</div>
            <div class="pdContent">如果您对慕尼黑展览（上海）有限公司的数据保护有任何问题或建议，请联系我们： Compliance@mm-sh.com</div>
          </div>

        </div>
        <div style="text-align:center;margin-top:30px"> <el-button type="primary" @click="yszcVisible = false">确定</el-button> </div>
        
    </el-dialog>


  </div>
</template>
<script>
import api from '../api'
import utils from '../utils'
import regExp from '../utils/regExp.js'
import Nav from '../components/Nav'
import CropperImage from '../components/CropperImage.vue';
import pmp from '../../static/img/pmp.png'
export default {
  name: 'BasicInfo',
  components: {
    Nav,
    CropperImage
  },
  data() {
    return {
      inputCofigData: [], // input 标签配置数据
      showBtnLoading: false, // load btn
      ruleForm2: {
        tabindex: 1,
        industry: '', // 行业
        userName: '', // 姓名
        comName: '', // 公司名
        sex: '',
        rank: '', // 职务
        depar: '', // 部门
        iphone: '',
        code: '', // 验证码
        email: '',
        webUrl: '',
        gNum: '', // 国家号前缀 :86
        gNum1: '',
        cNum: '', // 城市号前缀： 0312
        faxNum: '', // 传真座机号
        telNum: '', // 座机号
        cId: '', // 身份证号
        postcode: '', // 邮编
        remark: '', // 备注
        password: '',
        country: '',
        province: '',
        city: '',
        telGnum: '',
        addr: '',
        authorization: false
      },
      emailCopy: '',
      emailArr: [
        '@qq.com',
        '@163.com',
        '@126.com',
        '@yeah.net',
        '@vip.sina.com',
        '@sina.com',
        '@msn.com',
        '@hotmail.com',
        '@aol.com',
        '@ask.com',
        '@live.com'
      ],

      stepNum: 1,
      showCodeBtn: false, // 显示 code btn
      codeText: '获取验证码',
      countryArr: [], // 国家 or 特区 Arr
      provinceArr: [], // 省
      cityArr: [], // 城市
      showCountry: true, // 默认显示
      showProvince: false, //
      showCity: false,
      rg: /[0-9]{11}/,
      radio: 1, // 男女
      selectHttp: 'https:// ', // 选择协议
      showEmailTip: false,
      privacySwitch: false, // 是否显示 授权信息;
      privacyInfo: '', // 授权信息
      isChecked: true,
      isChecked2:true,
      ExhID: sessionStorage.getItem('ExhID'),
      PsjID: sessionStorage.getItem('PsjID'),
      IfSubmit: false,
      isLoading: false,
      previousEmail: '',
      isConsistencyIdCard: sessionStorage.getItem('isConsistencyIdCard') || '',
      syStyle: JSON.parse(sessionStorage.getItem('syStyle')) || {},
      confirmPassword: '', // 确认密码
      stepImg: [],
      btnAllStyle: sessionStorage.getItem('btnAll') ? JSON.parse(sessionStorage.getItem('btnAll')).styles : {},
      isRepeatIDCard: sessionStorage.getItem('isCheckIDCard') && sessionStorage.getItem('isCheckIDCard') === 'true',
      PhotoModel: JSON.parse(sessionStorage.getItem('PhotoModel')) || false,
      photoImg: sessionStorage.getItem('PhotoUrl') || '',
      IsRequiredPhoto: JSON.parse(sessionStorage.getItem('IsRequiredPhoto')) || false,
      pmp: pmp,
      // 裁切图片参数
      cropperModel: false,
      cropperName: '',
      imgName: '',
      imgVisible: false,
      yszcVisible: false
    }
  },
  computed: {
    faxNumber: function() {
      // 传真号全拼
      var str = ''
      if (this.ruleForm2.gNum === '086') {
        str =
          this.ruleForm2.gNum +
          '-' +
          this.ruleForm2.cNum +
          '-' +
          this.ruleForm2.faxNum
      } else {
        str = this.ruleForm2.gNum + '-' + this.ruleForm2.faxNum
      }
      return str
    },
    telNumber: function() {
      var str = ''
      if (this.ruleForm2.gNum === '086') {
        str =
          this.ruleForm2.gNum +
          '-' +
          this.ruleForm2.cNum +
          '-' +
          this.ruleForm2.telNum
      } else {
        str = this.ruleForm2.gNum + '-' + this.ruleForm2.telNum
      }
      return str
    }
  },
  mounted() {
    this.loadPageConfig() // 页面配置
    this.loadInputConfig() // input 配置
    this.initData()
    this.loadCountry(true)
    if (sessionStorage.getItem('stepImg')) {
      this.stepImg = JSON.parse(sessionStorage.getItem('stepImg'))
    } else {
      this.stepImg = []
    }
    utils.setThemeColor()
  },
  methods: {
    // 删除头像
    deletePhoto() {
      this.photoImg = ''
      sessionStorage.removeItem('PhotoUrl')
    },
    // 头像设置
    uploadPicture(name) {
      this.cropperName = name;
      this.cropperModel = true;
    },
    // 图片上传成功后
    handleUploadSuccess (data) {
      this.photoImg = data
      this.cropperModel = false;
    },
    clearSpace(n) {
      var obj = this.ruleForm2
      if (
        n === 'userName' ||
        n === 'comName' ||
        n === 'rank' ||
        n === 'depar' ||
        n === 'addr'
      ) {
        obj[n] = obj[n].trim()
      } else if (
        n === 'iphone' ||
        n === 'code' ||
        n === 'gNum' ||
        n === 'faxNum' ||
        n === 'cNum' ||
        n === 'telNum'
      ) {
        // 数字
        obj[n] = obj[n].replace(/\D/g, '')
      } else {
        obj[n] = obj[n].replace(/\s+/gim, '')
      }
      this.ruleForm2 = obj
      this.cacheInput()
      return false
    },
    initData() {
      // 载页面  数据初始化
      var obj = this.ruleForm2
      var uName = sessionStorage.getItem('cacheRegiater') || sessionStorage.getItem('cacheLogin')
      var uAddr = sessionStorage.getItem('cacheAdress')
      var cacheInfo = sessionStorage.getItem('cacheInfo')
      uName = JSON.parse(uName)
      uAddr = JSON.parse(uAddr)
      // 再次登陆，已注册，但未缓存数据
      if (this.PsjID) {
        api
          .getRegistInfo({
            ExhID: this.ExhID,
            PsjID: this.PsjID
          })
          .then(res => {
            if (res.data.status === 'OK') {
              var data = res.data.Data
              var obj = this.ruleForm2
              obj.addr = data.PsnAddress
              obj.city = data.PsnCity
              obj.comName = data.PsnComName
              obj.country = data.PsnCountry
              obj.province = data.PsnProvince
              obj.depar = data.PsnDept
              obj.email = data.PsnEmail
              // console.log(data.PsnFax === null, 'gggg')
              if (data.PsnFax !== null) {
                obj.faxNum = data.PsnFax.indexOf('-') > -1 ? data.PsnFax.split('-')[data.PsnFax.split('-').length - 1] : data.PsnFax
              }
              if (data.PsnTel !== null) {
                obj.telNum = data.PsnTel.indexOf('-') > -1 ? data.PsnTel.split('-')[data.PsnTel.split('-').length - 1] : data.PsnTel
              }
              obj.sex = data.PsnGender
              obj.cId = data.PsnIDCard
              obj.password = data.PsnLoginPwd
              obj.iphone = data.PsnMobile
              obj.userName = data.PsnName
              obj.rank = data.PsnRank
              obj.remark = data.PsnRemark
              obj.industry = data.PsnTrade
              obj.webUrl = data.PsnWebUrl
              obj.postcode = data.PsnZipCode
              if (obj.country === '中国大陆') {
                obj.gNum = '086'
                if (data.PsnTel && data.PsnTel.indexOf('-') > -1) {
                  let arr = data.PsnTel.split('-')
                  if (arr.length === 3) {
                    obj.cNum = arr[1]
                  }
                } else if (data.PsnFax && data.PsnFax.indexOf('-') > -1) {
                  let arr = data.PsnFax.split('-')
                  if (arr.length === 3) {
                    obj.cNum = arr[1]
                  }
                }
              } else {
                if (data.PsnTel && data.PsnTel.indexOf('-') > -1) {
                  obj.gNum = data.PsnTel.split('-')[0]
                } else if (data.PsnFax && data.PsnFax.indexOf('-') > -1) {
                  obj.gNum = data.PsnFax.split('-')[0]
                }
              }
              this.ruleForm2 = obj
              sessionStorage.setItem('dataInfo', JSON.stringify( res.data.Data))
            }
            this.previousEmail = this.ruleForm2.email
          })
      }
      // 首次进入 未注册
      if (!this.PsjID && obj.iphone === '' && !cacheInfo) {
        var param = {
          ExhID: this.ExhID,
          PsnMobile: uName.iphone ? uName.iphone : ''
        }
        //  获取往届信息
        api.getPeronInfo(param).then(res => {
          if (res.data.status === 'OK' && false) {
            obj.userName = uName.userName
            obj.comName = res.data.PsnComName
            obj.sex = res.data.PsnGender
            obj.rank = res.data.PsnRank
            obj.depar = res.data.PsnDept
            //  obj.iphone=res.data.PsnMobile;
            obj.iphone = uName.iphone
            obj.email = res.data.PsnEmail

            // cache for checking email change or not in edit mode
            this.previousEmail = res.data.PsnEmail

            obj.webUrl = res.data.PsnWebUrl

            obj.telGnum = obj.gNum = res.data.PsnTel.split('-')[0]
            let faxNumIndex = res.data.PsnFax.split('-').length - 1
            obj.faxNum = res.data.PsnFax.split('-')[faxNumIndex]
            let telNumIndex = res.data.PsnTel.split('-').length - 1
            obj.telNum = res.data.PsnTel.split('-')[telNumIndex]
            // obj.cId = res.data.PsnIDCard
            obj.postcode = res.data.PsnZipCode
            obj.country = res.data.PsnCountry
            this.ruleForm2 = obj
          } else {
            // 没有往届信息
            obj.userName = uName.userName ? uName.userName : ''
            obj.iphone = uName.iphone ? uName.iphone : ''
            if (uAddr && uAddr.MadProvince && uAddr.MadCity) {
              // obj.telGnum = obj.gNum = '086'
              // obj.cNum = uAddr.MadCityCode ? uAddr.MadCityCode : ''
              // obj.country = '中国大陆'
              // obj.province = uAddr.MadProvince ? uAddr.MadProvince : ''
              // obj.city = uAddr.MadCity ? uAddr.MadCity : ''
            }

            this.ruleForm2 = obj
          }
          this.$store.commit('setUserInfo', obj)
          sessionStorage.setItem('cacheInfo', JSON.stringify(obj))
        })
      } else {
        // 非第一加载
        if (cacheInfo) {
          obj = JSON.parse(cacheInfo)
          obj.iphone = uName.iphone
          this.ruleForm2 = obj
          this.previousEmail = this.ruleForm2.email
        }
      }
    },
    changeEmailOnce() {
      var isT = false
      this.cacheInput()
      return function() {
        if (isT) {
          if (this.ruleForm2.email) {
            this.showEmailTip = true
          } else {
            this.showEmailTip = false
          }
        } else {
          isT = true
        }
      }
    },
    changeEmail() {
      this.cacheInput()

      if (this.ruleForm2.email && this.ruleForm2.email.indexOf('@') < 0) {
        this.showEmailTip = true
      } else {
        this.showEmailTip = false
      }
    },
    chooseEmailSuffix(str) {
      this.ruleForm2.email = this.ruleForm2.email.split('@')[0] + str
      this.cacheInput()
      this.showEmailTip = false
    },
    cacheInput(str) {
      if (str === 'province') {
        var obj = this.ruleForm2
        obj.city = ''
        this.ruleForm2 = obj
      }
      sessionStorage.setItem('cacheInfo', JSON.stringify(this.ruleForm2))
    },

    loadCity(v) {
      var param = {
        ExhID: this.ExhID,
        zptProvince: this.ruleForm2.province
      }
      api.getCity(param).then(res => {
        if (res.data.status === 'OK') {
          var data = res.data.Data
          this.cityArr = data
        }
      })
    },
    changeCity(v) {
      var obj = this.ruleForm2
      var event = window.event
      var target = event.target || event.srcElement
      obj.cNum = v
      obj.city = target.innerText
      this.ruleForm2 = obj
      sessionStorage.setItem('cacheInfo', JSON.stringify(this.ruleForm2))
    },
    changeCountry(v) {
      var obj = this.ruleForm2
      obj.gNum1 = obj.gNum = obj.telGnum = v
      var event = window.event
      var target = event.target || event.srcElement
      obj.country = target.innerText
      if (target.innerText && target.innerText !== '中国大陆') {
        this.ruleForm2.province = ''
        this.ruleForm2.city = ''
      }
      this.ruleForm2 = obj
      sessionStorage.setItem('cacheInfo', JSON.stringify(this.ruleForm2))
    },
    loadProvince(v) {
      var param = {
        ExhID: this.ExhID
      }
      api.getProvince(param).then(res => {
        var data = res.data.Data
        if (data && data.length > 0) {
          this.provinceArr = data
          this.showProvince = true
        } else {
          this.provinceArr = []
          this.cityArr = []
        }
      })
    },
    loadCountry(v) {
      // 加载国家
      if (!v) {
        return ''
      }
      var param = {
        ExhID: this.ExhID
      }
      api.getCountry(param).then(res => {
        if (res.data.status === 'OK') {
          var data = res.data.Data
          var arr = []
          for (var i = 0; i < data.length; i++) {
            arr.concat(data[i])
          }
          this.countryArr = data
        } else {
          this.$alert(res.data.ErrorMsg)
        }
        this.isLoading = false
      })
    },
    loadPageConfig: function() {
      var param = {
        ExhID: this.ExhID,
        RegistType: 'pc',
        page: 'AddInfo',
        Language: 'cn'
      }
      api.getPage(param).then(res => {
        if (res.data.status === 'OK') {
          var switchInfos = res.data.switchInfos
          for (let i = 0; i < switchInfos.length; i++) {
            switch(switchInfos[i].name) {
              case 'IfSubmit':
                this.IfSubmit = switchInfos[i].data;
                sessionStorage.setItem('IfSubmit', this.IfSubmit);
                break;
              case 'PrivacySwitch':
                this.privacySwitch = switchInfos[i].data
                break;
            }
          }
          var promptinfo = res.data.promptinfo

          for (let i = 0; i < promptinfo.length; i++) {
            if (promptinfo[i].name === 'PrivacyInfo') {
              this.privacyInfo = promptinfo[i].value
            }
          }
        } else {
          this.$alert(res.data.ErrorMsg)
        }
      })
    },
    loadInputConfig() {
      var loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      var param = { ExhID: this.ExhID, RegistType: 'pc' }

      api.getinput(param).then(res => {
        if (res.data.status === 'OK') {
          this.inputCofigData = res.data.data.sort(this.sequence)
          loading.close()
        }
      })
    },
    sequence (a, b) {
      if (parseInt(a.BisSort) > parseInt(b.BisSort)) {
        return 1;
      } else if (parseInt(a.BisSort) < parseInt(b.BisSort)) {
        return -1
      } else {
        return 0;
      }
    },
    checkRepeatEmailCidCode(cb) {
      var param = {
        PsnEmail: this.ruleForm2.email,
        ExhID: this.ExhID
      }
      api.emailRepeat(param).then(res => {
        if (res.data.status === 'OK') {
          cb()
        } else {
          this.$alert(res.data.ErrorMsg, '提示', {
            dangerouslyUseHTMLString: true
          })
        }
      })
    },
    submitInfo() {
      var obj = this.ruleForm2
      this.showBtnLoading = true
      var param = {
        ExhID: this.ExhID,
        WapToken: sessionStorage.token,
        IfSubmit: this.IfSubmit,
        FaceID: '',
        RegistType: 'pc',
        InviteID: sessionStorage.getItem('InviteID')
          ? sessionStorage.getItem('InviteID')
          : 0,
        InviteType: sessionStorage.getItem('InviteType')
          ? sessionStorage.getItem('InviteType')
          : '',
        InviteCode: sessionStorage.getItem('InviteCode')
          ? sessionStorage.getItem('InviteCode')
          : '',
        PsnMobile: obj.iphone,
        PsnName: obj.userName,
        PsnComName: obj.comName,
        PsnGender: obj.sex,
        PsnRank: obj.rank,
        PsnDept: obj.depar,
        PsnCountry: obj.country,
        PsnEmail: obj.email,
        PsnWebUrl: obj.webUrl,
        PsnFax: obj.faxNum ? this.faxNumber : '',
        PsnTel: obj.telNum ? this.telNumber : '',
        PsnTrade: obj.industry,
        PsnIDCard: obj.cId,
        PsnLoginPwd: obj.password,
        PsnZipCode: obj.postcode,
        PsnRemark: obj.remark,
        PsnProvince: obj.province,
        PsnCity: obj.city,
        PsnCode: obj.code,
        PsnAddress: obj.addr,
        PsnCountryCode: obj.gNum1 === '086' ? obj.gNum1.slice(1) : obj.gNum1,
        PhotoUrl: sessionStorage.getItem('PhotoUrl') || ''
      }
      if (this.PsjID) {
        param.EntryPsjId = this.PsjID
        api.updateVisitor(param).then(res => {
          this.showBtnLoading = false
          if (res.data.status === 'OK') {
            sessionStorage.setItem('dataInfo', JSON.stringify(param))
            this.$alert('更新成功！', '提示')
            //  location.reload()
          } else {
            this.$alert(res.data.ErrorMsg, '提示')
          }
        })
      } else {

        if( param['InviteType']  == 'Actor'){
          param.PsnType = 'VIP'
          param.PsnLevel = '贵宾 VIP'
        }else{
          param.PsnType = ''
          param.PsnLevel = '观众 VISITOR'
        }

        api.saveVisitor(param).then(res => {
          this.showBtnLoading = false
          if (res.data.status === 'OK') {
            sessionStorage.PsnMobile = param.PsnMobile
            sessionStorage.setItem('dataInfo', JSON.stringify(param))
            if (res.data.PsjID) {
              if (sessionStorage.getItem('IsRegistActivity') && sessionStorage.getItem('IsRegistActivity') === 'true') { // 如果有会议跳转到选择会议页面
                this.$router.push({
                  path: 'meeting',
                  query: { ExhID: this.ExhID }
                })
              } else {
                this.$router.push({
                  path: 'confirmation',
                  query: { ExhID: this.ExhID }
                })
              }
              sessionStorage.setItem('PsjID', res.data.PsjID)
            } else {
              this.$router.push({
                path: 'questionnaire',
                query: { ExhID: this.ExhID }
              })
            }
          } else {
            this.$alert(res.data.ErrorMsg, '提示')
          }
        })
      }
    },
    async submit(elemRef) {
      var arr = this.inputCofigData
      var obj = this.ruleForm2
      if (this.IsRequiredPhoto && !this.photoImg) { // 头像必填
        this.$alert('请上传头像')
        return false;
      }
      for (var i = 0; i < arr.length; i++) {
        var o = arr[i]
        if (o.name === 'PsnName') {
          if (o.required && o.optional) {
            if (!regExp.notEmpty.test(obj.userName)) {
              this.$alert('请输入您的' + o.title)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (obj.userName.length < 2) {
              this.$alert(o.title + '长度不能小于2位')
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (
              !regExp.regCheckCnName.test(obj.userName) &&
              !regExp.regCheckEnName.test(obj.userName)
            ) {
              this.$alert(o.title + '格式填写错误,请重新输入')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else if (o.optional) {
            if (obj.userName && obj.userName.length < 2) {
              this.$alert(o.title + '长度不能小于2位')
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (
              !regExp.regCheckCnName.test(obj.userName) &&
              !regExp.regCheckEnName.test(obj.userName) &&
              obj.userName
            ) {
              this.$alert(o.title + '格式填写错误,请重新输入')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else {
            obj.userName = ''
          }
        } else if (o.name === 'PsnComName') {
          if (o.required && o.optional) {
            if (!regExp.notEmpty.test(obj.comName)) {
              this.$alert('请输入您的' + o.title)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (obj.comName.length < 4) {
              this.$alert(o.title + '长度不能小于4位')
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (!regExp.regCheckComName.test(obj.comName)) {
              this.$alert(o.title + '格式填写错误,请重新输入')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else if (o.optional) {
            if (obj.comName && obj.comName.length < 4) {
              this.$alert(o.title + '长度不能小于4位')
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (
              !regExp.regCheckComName.test(obj.comName) &&
              obj.comName
            ) {
              this.$alert(o.title + '格式填写错误,请重新输入')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else {
            obj.comName = ''
          }
        } else if (o.name === 'PsnGender') {
          if (o.required && o.optional) {
            if (!obj.sex) {
              this.$alert('请选择' + o.title)
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          }
        } else if (o.name === 'PsnRank') {
          if (o.required && o.optional) {
            if (!regExp.notEmpty.test(obj.rank)) {
              this.$alert('请输入您的' + o.title)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (obj.rank.length < 2) {
              this.$alert(o.title + '长度不能小于2位')
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (!regExp.regCheckRank.test(obj.rank)) {
              this.$alert(o.title + '格式填写错误,请重新输入')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else if (o.optional) {
            if (obj.rank && obj.length < 2) {
              this.$alert(o.title + '长度不能小于2位')
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (!regExp.regCheckRank.test(obj.rank) && obj.rank) {
              this.$alert(o.title + '格式填写错误,请重新输入')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else {
            obj.rank = ''
          }
        } else if (o.name === 'PsnDept') {
          if (o.required && o.optional) {
            if (!regExp.notEmpty.test(obj.depar)) {
              this.$alert('请输入您的' + o.title)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (obj.depar.length < 2) {
              this.$alert(o.title + '长度不能小于2位')
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (!regExp.regCheckDepar.test(obj.depar)) {
              this.$alert(o.title + '格式填写错误,请重新输入')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else if (o.optional) {
            if (obj.depar && obj.depar.length < 2) {
              this.$alert(o.title + '长度不能小于2位')
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (!regExp.regCheckDepar.test(obj.depar) && obj.depar) {
              this.$alert(o.title + '格式填写错误,请重新输入')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else {
            obj.depar = ''
          }
        } else if (o.name === 'PsnMobile') {
          if (o.required && o.optional) {
            if (!regExp.notEmpty.test(obj.iphone)) {
              this.$alert('请输入您的' + o.title)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (obj.iphone.length !== 11) {
              this.$alert('请输入11位的' + o.title)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (!regExp.regCheckCnMobile.test(obj.iphone)) {
              this.$alert(o.title + '格式填写错误,请重新输入')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else if (o.optional) {
            if (obj.iphone && obj.iphone.length !== 11) {
              this.$alert('请输入11位的' + o.title)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (
              !regExp.regCheckCnMobile.test(obj.iphone) &&
              obj.iphone
            ) {
              this.$alert('请输入11位的' + o.title)
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else {
            obj.iphone = ''
          }
        } else if (o.name === 'PsnCountry') {
          if (o.required && o.optional) {
            if (!obj.country) {
              this.$alert('请选择' + o.title)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (obj.country && obj.country !== '中国大陆') {
              obj.province = ''
              obj.city = ''
            }
          }
        } else if (o.name === 'PsnProvince') {
          if (o.required && o.optional) {
            if (!obj.province && obj.country === '中国大陆') {
              this.$alert('请选择' + o.title)
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          }
        } else if (o.name === 'PsnCity') {
          if (o.required && o.optional) {
            if (!obj.city && obj.country === '中国大陆') {
              this.$alert('请选择' + o.title)
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          }
        } else if (o.name === 'PsnEmail') {
          if (o.required && o.optional) {
            if (!regExp.notEmpty.test(obj.email)) {
              this.$alert('请输入您的' + o.title)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (!regExp.regCheckEmail.test(obj.email)) {
              this.$alert(o.title + '格式填写错误,请重新输入')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else if (o.optional) {
            if (!regExp.regCheckEmail.test(obj.email) && obj.email) {
              this.$alert(o.title + '格式填写错误,请重新输入')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else {
            obj.email = ''
          }
        } else if (o.name === 'PsnWebUrl') {
          if (o.required && o.optional) {
            if (!regExp.notEmpty.test(obj.webUrl)) {
              this.$alert('请输入您的' + o.title)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (!regExp.regWebUrl.test(obj.webUrl)) {
              this.$alert(o.title + '格式填写错误,请重新输入')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else if (o.optional) {
            if (!regExp.regWebUrl.test(obj.webUrl) && obj.webUrl) {
              this.$alert(o.title + '格式填写错误,请重新输入')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else {
            obj.webUrl = ''
          }
        } else if (o.name === 'PsnFax') {
          if (o.required && o.optional) {
            if (!obj.faxNum || !regExp.notEmpty.test(obj.faxNum)) {
              this.$alert('请输入您的' + o.title)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (
              (obj.faxNum.length < 7 || obj.faxNum.length > 8) &&
              obj.country === '中国大陆'
            ) {
              this.$alert('请输入7-8位的' + o.title)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (
              (obj.faxNum.length < 5 || obj.faxNum.length > 11) &&
              obj.country !== '中国大陆'
            ) {
              this.$alert('请输入5-11位的' + o.title)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (
              !regExp.regCheckTelCn.test(this.faxNumber) &&
              !regExp.regCheckTelEn.test(this.faxNumber)
            ) {
              this.$alert(o.title + '格式填写错误,请重新输入')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else if (o.optional) {
            if (
              obj.faxNum &&
              (obj.faxNum.length < 7 || obj.faxNum.length > 8) &&
              obj.country === '中国大陆'
            ) {
              this.$alert('请输入7-8位的' + o.title)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (
              obj.faxNum &&
              (obj.faxNum.length < 5 || obj.faxNum.length > 11) &&
              obj.country !== '中国大陆'
            ) {
              this.$alert('请输入5-11位的' + o.title)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (
              obj.faxNum &&
              !regExp.regCheckTelCn.test(this.faxNumber) &&
              !regExp.regCheckTelEn.test(this.faxNumber)
            ) {
              this.$alert(o.title + '格式填写错误,请重新输入')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else {
          }
        } else if (o.name === 'PsnTel') {
          if (o.required && o.optional) {
            if (!obj.telNum || !regExp.notEmpty.test(obj.telNum)) {
              this.$alert('请输入您的' + o.title)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (
              (obj.telNum.length < 7 || obj.telNum.length > 8) &&
              obj.country === '中国大陆'
            ) {
              this.$alert('请输入7-8位的' + o.title)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (
              (obj.telNum.length < 5 || obj.telNum.length > 11) &&
              obj.country !== '中国大陆'
            ) {
              this.$alert('请输入5-11位的' + o.title)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (
              !regExp.regCheckTelCn.test(this.telNumber) &&
              !regExp.regCheckTelEn.test(this.telNumber)
            ) {
              this.$alert(o.title + '格式填写错误,请重新输入')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else if (o.optional) {
            if (
              obj.telNum &&
              (obj.telNum.length < 7 || obj.telNum.length > 8) &&
              obj.country === '中国大陆'
            ) {
              this.$alert('请输入7-8位的' + o.title)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (
              obj.telNum &&
              (obj.telNum.length < 5 || obj.telNum.length > 11) &&
              obj.country !== '中国大陆'
            ) {
              this.$alert('请输入5-11位的' + o.title)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (
              obj.telNum &&
              !regExp.regCheckTelCn.test(this.telNumber) &&
              !regExp.regCheckTelEn.test(this.telNumber)
            ) {
              this.$alert(o.title + '格式填写错误,请重新输入')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else {
          }
        } else if (o.name === 'PsnTrade') {
          if (o.required && o.optional) {
            if (!obj.industry) {
              this.$alert('请选择' + o.title)
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else if (!o.optional) {
            obj.industry = ''
          }
        } else if (o.name === 'PsnIDCard') {
          console.log(obj.industry,'22222222222222222222222')
          if (o.required && o.optional) {
            if (!regExp.notEmpty.test(obj.cId)) {
              this.$alert('请输入您的' + o.title)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (obj.industry.indexOf('身份证') > -1  && (!utils.regCId(obj.cId) ||  utils.regCId(obj.cId) === '1'  ) ) {
    
              
              if(  !utils.regCId(obj.cId) ){
                this.$alert(o.title + '不合法,请重新输入')
              }
              if(  utils.regCId(obj.cId) === '1' ){
                this.$alert('16岁以下不能注册!')
              }

             
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else if (o.optional) {
            if (!utils.regCId(obj.cId) && obj.cId && obj.industry.indexOf('身份证') > -1) {
              this.$alert(o.title + '不合法,请重新输入')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else {
            obj.cId = ''
          }
        } else if (o.name === 'PsnLoginPwd') {
          if (o.required && o.optional) {
            if (!regExp.notEmpty.test(obj.password)) {
              this.$alert('请输入您的' + o.title)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (obj.password.length < 6) {
              this.$alert(o.title + '长度不能小于6位')
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (!regExp.password.test(obj.password)) {
              this.$alert('格式填写错误,请重新输入' + o.title)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (!this.confirmPassword) {
              this.$alert('请再次输入密码')
              document.getElementsByName('confirmPassword')[0].focus()
              return ''
            } else if (obj.password !== this.confirmPassword) {
              this.$alert('两次输入密码不一致')
              document.getElementsByName('confirmPassword')[0].focus()
              return ''
            }
          } else if (o.optional) {
            if (obj.password && obj.password.length < 6) {
              this.$alert(o.title + '长度不能小于6位')
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (!regExp.password.test(obj.password) && obj.password) {
              this.$alert('格式填写错误,请重新输入' + o.title)
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else {
            obj.password = ''
          }
        } else if (o.name === 'PsnZipCode') {
          if (o.required && o.optional) {
            if (!regExp.notEmpty.test(obj.postcode)) {
              this.$alert('请输入您的' + o.title)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (!regExp.checkCnZipCode.test(obj.postcode)) {
              this.$alert(o.title + '格式填写错误,请重新输入')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else if (o.optional) {
            if (!regExp.checkCnZipCode.test(obj.postcode) && obj.postcode) {
              this.$alert(o.title + '格式填写错误,请重新输入')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else {
            obj.postcode = ''
          }
        } else if (o.name === 'PsnRemark') {
          if (o.required && o.optional) {
            if (!regExp.notEmpty.test(obj.remark)) {
              this.$alert('请输入您的' + o.title)
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else if (!o.optional) {
            obj.remark = ''
          }
        } else if (o.name === 'PsnAddress') {
          if (o.required && o.optional) {
            if (!regExp.notEmpty.test(obj.addr)) {
              this.$alert('请输入您的' + o.title)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (obj.addr.length < 6) {
              this.$alert(o.title + '长度不能小于6位')
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (!regExp.checkAddress.test(obj.addr)) {
              this.$alert(o.title + '格式填写错误,请重新输入')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else if (o.optional) {
            if (obj.addr && obj.addr.length < 6) {
              this.$alert(o.title + '长度不能小于6位')
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (obj.addr && !regExp.checkAddress.test(obj.addr)) {
              this.$alert(o.title + '格式填写错误,请重新输入')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else {
            obj.addr = ''
          }
        }
      }
      if (this.privacySwitch && !this.isChecked) {
        this.$alert('请勾选隐私协议')
        return ''
      }
      if (this.privacySwitch && !this.isChecked2) {
        this.$alert('请勾选隐私协议')
        return ''
      }

      if (this.isRepeatIDCard) { // 如果身份证号查重
        await this.checkIDCardRepeat()
      } else {
        this.idRepeatRes = true
      }
      if (this.idRepeatRes) { // 如果通过证件查重
        this.ruleForm2 = obj
        // 姓名身份证号一致性验证
        // 如果有身份证 没有国家或国家为中国大陆 进行一致性验证
        // obj.industry.indexOf('身份证') > -1
        // if (this.ruleForm2.cId && (this.ruleForm2.country === '中国大陆' || this.ruleForm2.country === '中国' || this.ruleForm2 === '') && this.isConsistencyIdCard === 'true') {
        if (this.ruleForm2.cId && (obj.industry.indexOf('身份证') > -1) && this.isConsistencyIdCard === 'true') {
          utils.realNameVerification(this, this.ruleForm2.userName, this.ruleForm2.cId).then(resRealName => {
            if (resRealName === 'true') {
              if (this.previousEmail === this.ruleForm2.email) {
                this.submitInfo()
              } else {
                this.checkRepeatEmailCidCode(this.submitInfo)
              }
            } else {
              this.$alert('您输入的姓名和身份证号不一致', '提示', {
                dangerouslyUseHTMLString: true
              })
            }
          })
        } else {
          if (this.previousEmail === this.ruleForm2.email) {
            this.submitInfo()
          } else {
            this.checkRepeatEmailCidCode(this.submitInfo)
          }
        }
      } else {
        this.$alert('此证件号已在本届展会注册！')
      }
      return false
    },
    async checkIDCardRepeat() {
      await api.IDCardRepeat({
        exhid: sessionStorage.getItem('ExhID'),
        PsnIDCard: this.ruleForm2.cId
      }).then(res => {
        if (res.data.status === 'OK') {
          this.idRepeatRes = true
        } else {
          this.$alert(res.data.ErrorMsg, '提示', {
            dangerouslyUseHTMLString: true
          })
          this.idRepeatRes = false
        }
      })
    },
    getCode() {
      var num = this.ruleForm2.iphone
      if (num && regExp.regCheckCnMobile.test(num)) {
        var param = {
          exhid: this.ExhID,
          PsnMobile: num
        }
        api.mobileRepeat(param).then(res => {
          if (res.data.FaceIDstatus === 'OK') {
            // var params = {
            //   sign: '昆仑亿发',
            //   source: 'pc',
            //   token: sessionStorage.token,
            //   mobile: num
            // }
            //  $.post(api.getCodeInterface,params,function(res){
            //    if(res.data.status=="OK"){
            //      this.showCodeBtn=true;
            //      clearInterval(stop);
            //      var index=59;
            //      var stop=setInterval(function(){
            //        if(index<0){
            //          clearInterval(stop);
            //          this.codeText="获取验证码";
            //          this.showCodeBtn=false;
            //          return '';
            //        }
            //        this.codeText=index;
            //        index--;
            //      },1000);
            //    }else{
            //      this.$alert(res.data.ErrorMsg, '提示',{
            //        dangerouslyUseHTMLString: true
            //      });
            //    }
            //  });
          } else {
            this.$alert(res.data.ErrorMsg, '提示', {
              dangerouslyUseHTMLString: true
            })
          }
        })
      } else {
        this.$alert('请输入正确的手机号', '提示', {
          dangerouslyUseHTMLString: true
        })
      }
    }
  }
}
</script>
<style lang="scss">
.ystkBox{

}
.ystkBox .smallTip{
  font-weight: bold;
  font-size:16px;
  padding-bottom: 10px;
}
.ystkBox .pdText{
  padding-bottom: 24px;
}
.ystkBox .pdContent{
  font-size:14px;
  line-height: 20px;
}
.photoImg{
  display:inline-block;
  width:100%;
  position:relative;
  border:1px solid #DCDFE6;
  border-radius: 6px;
  padding:10px;
}
.photoImg .photoBtns{
  text-align: right;
}
.personInfobox{
  box-shadow: 0 2px 8px #c3d9eb;
  border-radius: 8px;
  overflow: hidden;
  background-color: #fff;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type='number'] {
  -moz-appearance: textfield;
}
.form-item {
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin: 10px auto;
  position: relative;
}
.form-item.sex {
  -webkit-justify-content: flex-start;
  -ms-justify-content: flex-start;
  -o-justify-content: flex-start;
  justify-content: flex-start;
}
.form-item > div {
  min-width: 20%;
  line-height: 40px;
  text-align: right;
  padding-right: 8px;
}
.el-radio {
  line-height: 40px;
}
#personInfo {
  .el-input,
  .el-select {
    width: 86%;
  }
  .el-select .el-input {
    width: 100%;
  }
}

.from-wrap {
  box-sizing: border-box;
}
.form-item.tel{
  width: 100%;
}
.tel input {
  width: 100%;
}
.email-tip {
  position: absolute;
  width: 80%;
  left: 50%;
  top: 50px;
  transform: translate(-50%);
  z-index: 99;
}
.el-step {
  flex-basis: auto !important;
  width: 33% !important;
}
.email-tip .email-tip-option {
  word-wrap: break-word;
  margin: 10px 0;
}
.privacySwitch {
  margin: 10px 0;
  padding-left: 10px;
  display: flex;
  align-items: center;
}
.privacySwitch .privacyTxt{
  margin-left: 6px;
  font-size: 12px;
  text-decoration: underline;
  cursor: pointer;
}
.privacyTxt2{
  margin-left: 6px;
  font-size: 12px;
  line-height: 18px;
}
.privacySwitch .el-checkbox__label {
  white-space: normal;
  word-wrap: break-word;
  word-break: break-all;
  vertical-align: top;
}
.step-box2 .el-steps {
  -webkit-justify-content: center;
  justify-content: center;
  -moz-box-pack: center;
  box-pack: center;
}
.info_content_row {
  margin-bottom: 22px;
}
.info_tit_box {
  text-align: right;
}
.info_tit {
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  text-align: right;
}
.sex_box {
  line-height: 40px;
}
.info_tips {
  margin-left: 100px;
  margin-bottom: 22px;
  color: red;
}
.el-select {
  width: 100%;
}
.info_code_btn {
  height: 40px;
  line-height: 40px;
  text-align: center;
  border-radius: 4px;
  cursor: pointer;
}
/*new --------------*/
.el-message-box {
  max-width: 80%;
}
.el-select-dropdown {
  transform-origin: center top 0px;
}
#app {
  width: 100%;
}
body {
  background: #f0f0f0;
}
.img-auto {
  width: 100%;
}
.title {
  text-align: left;
  font-size: 16px;
  font-weight: 600;
  padding: 60px 80px 30px;
  background: #fff;
  border-bottom: 1px solid #eee;
}
.banner-box {
  width: 100%;

  margin: 0 auto;
}
.from-wrap {
  max-width: 980px;
  margin: 0 auto;
  padding: 14px;
}
.from-wrap > div {
  max-width: 480px;
  margin: 0 auto;
}
.flex {
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: space-between;
  justify-content: space-between;
}
.flex-start {
  display: flex;
  justify-content: flex-start;
}
.tel .el-form-item__content {
  display: flex;
  justify-content: flex-start;
}
.code-btn {
  height: 40px;
}
.Personinfo-submit-btn {
  margin: 30px auto !important;
  display: block !important;
  width: 50%;
}

.email-tip {
  background: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  box-sizing: border-box;

  color: #606266;
}
.email-tip .email-tip-option {
  padding: 0px 15px;
  height: 34px;
  line-height: 34px;
  text-align: left;
}
.email-tip .email-tip-option:hover {
  background: #f5f7fa;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/BasicInfo.vue